import { AxiosResponse } from 'axios';
import AxiosApi from '../../api/AxiosApi';

import { HttpRequestContract } from '../../../domain/contract/HttpContract';

/**
 * AuthCall - chamada responsavel pela autenticação, não tem token
 * @param request
 * @constructor
 */
export async function AuthCall(request: HttpRequestContract) {
  let axiosResponse: AxiosResponse;
  
  axiosResponse = await AxiosApi.request({
    url: request.url,
    method: request.method,
    data: request.body,
    headers: request.headers,
  });

  return {
    statusCode: axiosResponse.status,
    headers: axiosResponse.headers,
    body: axiosResponse.data,
  };
}
